
<app-common-header></app-common-header>
<br />
<br />
<div class="container">
    <div class="row">
        <div class="col-md-9">
            <h1>{{pageheadername}}</h1>
            <br />
            <!-- <h4  class="pageheading3 {{this.pageheadername.indexOf('Edit') > -1 ? 'username' :'' }}  {{this.Status == 'Archived' ? 'pending' : this.Status == 'Active' ? 'active' : this.Status == 'Suspended' ? 'suspend' :'inactive' }}" style="text-transform:capitalize;line-height: 1;">
              {{this.Status}}
            </h4> -->
        </div>
          
    </div>
    <div class="row">
        <div class="col-md-12">
            <form (ngSubmit)="AddEditAffilations(managerMaintenanceForm.value)" [formGroup]="managerMaintenanceForm" role="form" novalidate autocomplete="false">
              <div class="row mt-3">
               
                <div class="col-md-6">
                  <label for="userId" class="control-label">Zipcode</label>
                  <input  maxlength="5" minlength="5" (keypress)="numberOnly($event)" data-number="true" type="text" class="form-control" id="Zip" formControlName="Zip" appNumericInput="true"/>
                  <mat-error *ngFor="let validation of account_validation_messages.Zip">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('Zip').hasError(validation.type) && (managerMaintenanceForm.get('Zip').dirty || managerMaintenanceForm.get('Zip').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                </div>
                <div class="col-md-6">
                  <label for="userId" class="control-label">Utility Name</label>
                 
                  <ng-select [items]="utilityList" bindLabel="Utility"
                  bindValue="_id" placeholder="Select" [searchable]="false" [clearable]="false"
                  id="Utility" 
                  formControlName="Utility">
                  </ng-select>
                  <mat-error *ngFor="let validation of account_validation_messages.Utility">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('Utility').hasError(validation.type) && (managerMaintenanceForm.get('Utility').dirty || managerMaintenanceForm.get('Utility').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                </div>
              </div>

              <div class="row mt-3">
               
                <div class="col-md-6">
                  <label for="userId" class="control-label">City</label>
                  <input  type="text" class="form-control" id="City" formControlName="City" />
                  <mat-error *ngFor="let validation of account_validation_messages.City">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('City').hasError(validation.type) && (managerMaintenanceForm.get('City').dirty || managerMaintenanceForm.get('City').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                </div>
                <div class="col-md-6">
                  <label for="userId" class="control-label">State</label>
                  <input   type="text" class="form-control" id="State" formControlName="State" />
                  <mat-error *ngFor="let validation of account_validation_messages.State">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('State').hasError(validation.type) && (managerMaintenanceForm.get('State').dirty || managerMaintenanceForm.get('State').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                </div>
              </div>
          
      
              <div class="pull-right mt-2">
                
                <button type="submit"  [disabled]="!managerMaintenanceForm.valid" class="mr-2 mt-0 btn sectbtn brdrRadius " >Save</button>
                <button type="button" (click)="navigateToAnotherComponent()"   class="mr-2 mt-0 btn sectbtn brdrRadius " >Cancel</button>
              </div>
            </form>
            <!-- <input matInput [(ngModel)]="data.animal"> -->
        </div>
    </div>
</div>
<ng-template #SuccessModel>
  <div class="modal-header py-0 px-1 pt-1">
    <div class="col-12 text-right py-0 px-0">
      <!-- <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button> -->
      <h4
      class="utility-modal-title font20 text-center text-uppercase"
    
    >
    {{title}}
    </h4> 
   
    </div>
  </div>
  <div class="modal-body pt-0" style="text-align: center;">

    <p class="utility-sub-title font20">
    {{msg}}
    </p>
   
    <button type="button"  class="mr-2 mt-0 btn sectbtn brdrRadius "(click)="modalRef.hide()" >OK</button>

  </div>
</ng-template>


  
  
